import type { SessionFeatures } from 'core/session/sessionReducers'

// ACF-FR-001: Advanced Configuration (a Beta feature) is on unless the DU turns it off with
// ENABLE_ADVANCED_CONFIGURATION=false. A features.json without the key keeps it on.
export const isAdvancedConfigurationEnabled = (features?: SessionFeatures): boolean =>
  features?.advanced_configuration !== false
